
  import { Component, Vue } from 'vue-property-decorator'
  import { routePaths } from '@/router'

  //TODO: Need to setup route / authservice to make it here in the event we are offline.
  @Component
  export default class Offline extends Vue {
    navToHome() {
      this.$router.push(routePaths.home.path);
    }
  }
